export default "__VITE_ASSET__91181de2__"